import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from 'src/environments/environment'

/** Fincart lead capture — mirrors stacks-agents `src/app/api/fincart/`. */
@Injectable({ providedIn: 'root' })
export class FincartApiService {
  constructor(private http: HttpClient) {}

  /** Builder JWT for the stacks-agents API. */
  private agentsAuthHeaders(): HttpHeaders {
    return new HttpHeaders({ Authorization: `Bearer ${localStorage.getItem('token')}` })
  }

  getFincartLead(projectId: string): Promise<Record<string, any> | null> {
    return this.http
      .get<{ data?: Record<string, any> }>(`${environment.agentsUrl}v4/retrieval/fincart-lead`, {
        headers: this.agentsAuthHeaders(),
        params: { projectId },
      })
      .pipe(
        map(body => body?.data ?? null),
        catchError(() => of(null)),
      )
      .toPromise() as Promise<Record<string, any> | null>
  }

  /** Upserts a project's Fincart lead submission (one row per project). */
  async upsertFincartLead(projectId: string, lead: {
    name: string;
    email: string;
    phone: string;
    avg_monthly_orders: string;
    brand: string;
    industry: string;
  }): Promise<void> {
    await this.http
      .post(`${environment.agentsUrl}v4/creation/fincart-lead`, { projectId, lead }, {
        headers: this.agentsAuthHeaders(),
      })
      .pipe(catchError(() => of(null)))
      .toPromise()
  }
}
